module.exports = __webpack_public_path__ + "static/media/kiss-wink-heart.a360c877.svg";